<template>
  <div class="raceIntroduction">
    <childLogo></childLogo>
    <div class="navbar-dark">
      <div class="container">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">赛事介绍</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;">全国青年科普创新实验暨作品大赛</div>
        <div>
          <div class="firstLevel">二、活动时间</div>
          <div class="firstLevel">二、活动时间</div>
          <div class="firstLevel">二、活动时间</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";

export default {
  components: {
    ChildLogo: ChildLogo
  },
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped>
.raceIntroduction{
  min-height: 1000px;
}

.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0c70fc;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

.firstLevel {
  text-align: left;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/RaceIntroduction.vue